import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
//import AppTest from './AppTest';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
reportWebVitals(console.log);
